import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MdSnackBar } from '@angular/material';
import { Version } from '../../models/Version';
import { Product } from '../../models/Product';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';

import { FormControl } from '@angular/forms';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
    selector: 'versionedit',
    providers: [AuthService], 
    templateUrl: './versionedit.component.html',
    styleUrls: ['./versionedit.component.css']
})
export class VersionEditComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
        ];

    version: Version = new Version();
    originalVersion: Version = new Version();

    products: Product[] = [];
    selectedProducts: Product[] = [];
    searchProductText: string = '';

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, private route: ActivatedRoute) {
        if (!this.auth.authenticated) {
            this.snackBar.open('Please login', null, {
                duration: 3000,
            });
        }

        this.productCtrl = new FormControl();
        this.filteredProducts = this.productCtrl.valueChanges
            .startWith(null)
            .map(query => this.filterProducts(query));

        let versionId = route.snapshot.params['id'];
        if (versionId > 0) {
            this.busy = true;
            this.getVersion(versionId);
        } else {
            this.version = new Version();
            this.version.ReleaseDate = new Date(Date.now());
        }

        this.getProducts();
    }

    cancel() {
            this.version = Object.assign({}, this.originalVersion);
            /*this.version = new Version(
            this.originalVersion.Id,
            this.originalVersion.VersionName,
            this.originalVersion.VersionNumber,
            this.originalVersion.ReleaseDate,
            this.originalVersion.ReleaseNotes,
            this.originalVersion.EngrNotes,
            this.originalVersion.Status,
            this.originalVersion.Url,
            this.originalVersion.Hash          
        );*/
    }

    getVersion(id: number) {
        this.softwareService.getVersionById(id).subscribe(result => {
            this.originalVersion = result.json();
            this.version = Object.assign({}, this.originalVersion);

            this.softwareService.getProductsForVersion(id).subscribe(result => {
                this.selectedProducts = result.json();
                this.busy = false;
            }, err => {
                this.busy = false;
                this.selectedProducts = [];
                this.snackBar.open('Error loading version\'s products', null, { duration: 3000 });
            });
        }, err => {
            this.busy = false;
            this.version = new Version();
            this.snackBar.open('Error loading version', null, { duration: 3000 });
        });
    }

    getProducts() {
        this.softwareService.getProducts().subscribe(result => {
            this.products = result.json();
        }, err => {
            this.snackBar.open('Error loading products', null, { duration: 3000 });
        });
    }

    saveVersion(newVersion: Version, products: Product[]) {
        this.busy = true;
        if (this.auth.authenticated && this.auth.hasPermission('write:versions')) {
            this.softwareService.saveVersion(newVersion).subscribe(result => {
                console.log('Post version result: ', result);
                if (result.ok) {
                    this.originalVersion = result.json();
                    this.version = Object.assign({}, this.originalVersion);

                    let productIds = products.map(p => p.Id);
                    this.softwareService.saveVersionProducts(this.version.Id, productIds).subscribe(result => {
                        this.busy = false;
                        this.snackBar.open('Version Saved', null, {
                            duration: 3000,
                        });
                    }, err => {
                        this.busy = false;
                        this.snackBar.open('Error saving products for version', null, {
                            duration: 3000,
                        });
                    });
                } else {
                    this.busy = false;
                    this.snackBar.open('Error saving version', null, {
                        duration: 3000,
                    });
                }
            }, err => {
                this.busy = false;
                this.snackBar.open('Error saving version', null, {
                    duration: 3000,
                });
            });
        } else {
            this.busy = false;
            this.snackBar.open('Please login', null, {
                duration: 3000,
            });
        }
    }

    fileUpload(event) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];

            this.softwareService.uploadVersion(file).subscribe(result => {
                let res = result.json();
                this.version.Url = res.url;
                this.version.Hash = res.hash;
            }, err => {
                this.snackBar.open('File upload error - try again', null, {
                    duration: 3000,
                });
            });
        }
    }

    productCtrl: FormControl;
    filteredProducts: any;

    filterProducts(query: string) {
        return query ? this.products.filter(p => {
            if (this.selectedProducts.indexOf(p) !== -1) {
                return false;
            }
            return ((p.UpdateId.toLowerCase().indexOf(query.toLowerCase()) === 0) ||
                (p.Name.toLowerCase().indexOf(query.toLowerCase()) === 0));
        })
            : this.products.filter(p => this.selectedProducts.indexOf(p) === -1);
    }

    onProductSelected(prod: Product, event: any) {
        if (event.isUserInput) {
            this.selectedProducts.push(prod);
            this.productCtrl.reset();
        }
    }

    removeSelectedProduct(removedProduct: Product) {
        this.selectedProducts = this.selectedProducts.filter(p => p !== removedProduct);
    }
}



// WEBPACK FOOTER //
// ./Client/app/containers/versionedit/versionedit.component.ts